import { Injectable, Injector } from '@angular/core';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { Observable } from 'rxjs';
import {
  ICreateSDAResponse,
  ISDADetailResponse
} from '../models';

@Injectable()
export class SDAService extends BaseApiService {

  constructor(protected injector: Injector) {
    super(injector);
  }
  get cadSdaUrl(): string {
    return `${this.endPointBP}/cad/sda`;
  }

  createSDADraft(): Observable<ICreateSDAResponse> {
    const endPoint = `${this.cadSdaUrl}/draft`;
    return this.httpAuthPost<ICreateSDAResponse>(endPoint, {});
  }

  submitSDA(caseId: string): Observable<ISDADetailResponse> {
    const endPoint = `${this.cadSdaUrl}/draft/${caseId}/submit`;
    return this.httpAuthPost<ISDADetailResponse>(endPoint, {});
  }

  uploadDocument(): Observable<any> {
    const endpoint = `${this.cadSdaUrl}/upload`;
    return this.httpAuthPost(endpoint, {});
  }

  getSDADetails(caseId: string): Observable<ISDADetailResponse> {
    const endPoint = `${this.cadSdaUrl}/${caseId}`;
    return this.httpAuthGet<ISDADetailResponse>(endPoint);
  }
}
